import { render } from "./JobHistory.vue?vue&type=template&id=740895a0&scoped=true"
import script from "./JobHistory.vue?vue&type=script&lang=js"
export * from "./JobHistory.vue?vue&type=script&lang=js"

import "./JobHistory.vue?vue&type=style&index=0&id=740895a0&scoped=true&lang=scss"

import exportComponent from "/home/parmcoder/muic/Deguild-Project/deguild-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-740895a0"]])

export default __exports__